import food1 from "../assets/images/food/sample1.jpg"
import food2 from "../assets/images/food/sample2.jpg"

// Sample gallery photos
export const galleryPosts = [
    {
        alt: "food1",
        image: food1
    },
    {
        alt: "food1",
        image: food2
    },
    {
        alt: "food1",
        image: food1
    },
    {
        alt: "food1",
        image: food2
    },
    {
        alt: "food1",
        image: food1
    },
]